import { RequestError, RequestErrorArgs } from "./RequestError"

export class NotFoundError extends RequestError {
  constructor(args: RequestErrorArgs) {
    super(args)
    this.name = "NotFoundError"
  }

  // 404s are expected (e.g. accessing a project without permission) — not actionable
  // eslint-disable-next-line class-methods-use-this, @typescript-eslint/no-empty-function
  override async notify() {}
}
